<template>
  <div class="Query-partner">
    <div class="product-Item">
      <div class="introduction_r">
        <div class="introduction_nameBox">
          <el-page-header @back="goBack" :content="contentName"></el-page-header>
          <div class="searchBox">
            <el-input placeholder="请输入内容" v-model="keyword" @change="searchBtn">
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
          </div>
        </div>
        <div class="Query-cont" v-if="partners.length>0">
          <div class="QueryItem" v-for="(item,index) in partners" :key="index">
            <div class="QueryImage"><img :src="item.img" alt=""></div>
            <div class="Query-right">
              <div class="QueryName">{{item.fdName}}</div>
              <div class="QueryDsc">{{item.describes}}</div>
              <!-- <div class="QueryBtn">了解更多>></div> -->
            </div>
          </div>
          <div class="pagination">
            <el-pagination background layout="prev, pager, next" :total="totalElement" @current-change="changeCurrent"></el-pagination>
          </div>
        </div>
        <div class="empty" v-else>
          <el-empty :image-size="200"></el-empty>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      contentName:'',
      keyword:'',
      page:1,
      limit:10,
      partners:[],
      totalElement:0
    }
  },
  created(){
    this.contentName = this.$route.query.contentName
  },
  mounted(){
    this.getpartner()
  },
  methods:{
    changeCurrent(e){
      this.page = e
      this.getpartner()
    },
    searchBtn(){
      console.log(this.keyword)
      this.getpartner();
    },
    getpartner(){
      let url = "/userController/front/searchPartnerByFdName"
      let obj = {
        page:this.page,
        limit:this.limit
        }
      if(this.keyword){
        obj.keyword = this.keyword
      }
      this.$axios.post(url,obj).then(res=>{
        console.log(res)
        this.partners = res.data.data
        this.totalElement = res.data.totalElement
      })
    },
    goBack() {
      // history.go(-1)
      this.$router.go(-1);//返回上一层
    },
  }
}
</script>

<style scoped lang="less">
.product-Item {
  width: 1200px;
  margin: 15px auto;
  .introduction_r {
    // width: calc(1200px - 304px);
    .introduction_nameBox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 30px 0;
      // margin-bottom: 30px;
      border-bottom: 1px solid #e6e8ed;
      .searchBox{
        width: 360px;
      }
      .introduction_name {
        font-size: 30px;
        font-family: NotoSansHans-Regular, NotoSansHans;
        font-weight: 400;
        color: #333333;
      }
      .inputBox {
        width: 360px;
        height: 36px;
        // background: #FFFFFF;
        border-radius: 4px;
        // border: 1px solid #1373CF;
      }
    }
    .Query-cont {
      padding: 30px 0;
      .QueryItem{
        display: flex;
        width: 100%;
        height: 100%;
        cursor: pointer;
        margin-bottom: 24px;
        .QueryImage{
          width: 282px;
          height: 130px;
          margin-right: 24px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        .Query-right{
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          border-bottom: 1px solid #E6E8ED;
          width: calc(1200px - 306px);
          height: 130px;
          .QueryName{
            font-size: 18px;
            font-family: NotoSansHans-Medium, NotoSansHans;
            font-weight: 500;
            color: #333333;
            line-height: 27px;
            letter-spacing: 2px;
          }
          .QueryDsc{
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #333333;
            line-height: 24px;
            letter-spacing: 2px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .QueryBtn{
            font-size: 14px;
            font-family: NotoSansHans-Regular, NotoSansHans;
            font-weight: 400;
            color: #1373CF;
            line-height: 21px;
            letter-spacing: 2px;
          }
        }
      }
      .pagination{
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 30px 0;
      }
    }
  }
}
</style>